<div class="modal-header m-transparent">
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-header d-flex justify-content-center">
  <h3 class="modal-title text-center">{{"no-id.title"|translate}}</h3>
</div>

<div class="modal-body d-flex flex-column align-items-center">
  <button class="btn btn-primary my-1" (click)="goToNewRequest()">{{"no-id.new-request"|translate}}</button>
  <button class="btn btn-primary my-1" (click)="back()">{{"no-id.back"|translate}}</button>

  <span class="mt-4">{{"no-id.chat-text"|translate}}</span>
  <button class="btn btn-primary chat-btn m-0" (click)="openChat()">{{"no-id.chat-btn"|translate}}</button>
</div>


// WEBPACK FOOTER //
// ./src/app/no-id-dialog/no-id-dialog.component.html